import {
  CUSTOM_ELEMENTS_SCHEMA,
  Injector,
  ModuleWithProviders,
  NO_ERRORS_SCHEMA,
  NgModule,
} from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import {
  HTTP_INTERCEPTORS,
  HttpClient,
  HttpClientModule,
} from "@angular/common/http";
import { NgbModule, NgbPaginationModule } from "@ng-bootstrap/ng-bootstrap";
import { RouterModule } from "@angular/router";
import { TranslateModule } from "@ngx-translate/core";

import { AppInterceptor } from "./providers/interceptor/interceptor.service";
import { AuthGuard } from "./providers/guard/Auth/auth-guard.service";
import { ConfirmationDialogComponent } from "./components/confirmation-dialog/confirmation-dialog/confirmation-dialog.component";
import { ConfirmationDialogService } from "./providers/confirmation-dialog/confirmation-dialog.service";
import { ConvertGerogianToHijriPipe } from "./pipes/convert-date.pipe";
import { DatepickerGregorianComponent } from "./components/datepicker-gregorian/datepicker-gregorian.component";
import { DatepickerUmalquraComponent } from "./components/datepicker-umalqura/datepicker-umalqura.component";
import { EndpointsService } from "./providers/endpoints/endpoints.service";
import { FileUploadComponent } from "./components/file-upload/file-upload.component";
import { FooterComponent } from "./components/footer/footer.component";
import { GeneralErrorComponent } from "./components/general-error/general-error.component";
import { HeaderComponent } from "./components/header/header.component";
import { LandingHeaderComponent } from "./components/landing-header/landing-header.component";
import { LanguageSwitcherComponent } from "./components/language-switcher/language-switcher.component";
import { LoaderComponent } from "./components/loader/loader.component";
import { LoaderInterceptor } from "./providers/interceptor/loader-interceptor.service";
import { LoaderService } from "./components/loader/loader.service";
import { MomentPipe } from "./pipes/moment.pipe";
import { NgOptionHighlightModule } from "@ng-select/ng-option-highlight";
import { NgSelectModule } from "@ng-select/ng-select";
import { QueryService } from "./providers/query-service/query.service";
import { TranslateHttpLoader } from "@ngx-translate/http-loader";
import { UrlSerializerService } from "./providers/urlSerializer/url-serializer.service";
import { TrademarkInfoComponent } from "./components/trademark-info/trademark-info.component";
import { TradeMarkService } from "../services/TradeMarkService";
import { Select2Module } from "ng-select2-component";
import { SelectedValueDirective } from "./directives/selected-value.directive";
import { QcIdDirective } from "./directives/qcidselector.directive";
import { FileDownloadService } from "./providers/file-download/file-download.service";
import { SafeUrlPipe } from "./pipes/safe-url.pipe";
import { NgxIntlTelInputModule } from "ngx-intl-tel-input";
import { PhoneInputComponent } from "./components/phone-input/phone-input.component";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { AppInjector } from "./base/app-injector";
import { ToastrModule } from 'ngx-toastr';
import { BrowserModule } from "@angular/platform-browser";
import { AutoTabDirective } from './directives/auto-tab.directive';

const services = [
  ConfirmationDialogService,
  AuthGuard,
  QueryService,
  EndpointsService,
  LoaderService,
  UrlSerializerService,
  MomentPipe,
  TradeMarkService,
  FileDownloadService,
  SafeUrlPipe
];

const sharedModules = [
  CommonModule,
  HttpClientModule,
  ReactiveFormsModule,
  FormsModule,
  NgbPaginationModule,
  NgSelectModule,
  NgOptionHighlightModule,
  NgbModule,
  TranslateModule,
  Select2Module,
  RouterModule,
  NgxIntlTelInputModule,
  //BrowserModule,
  //BrowserAnimationsModule
];

const sharedMComponents = [
  LandingHeaderComponent,
  LanguageSwitcherComponent,
  HeaderComponent,
  FooterComponent,
  LoaderComponent,
  FileUploadComponent,
  DatepickerUmalquraComponent,
  DatepickerGregorianComponent,
  TrademarkInfoComponent,
  PhoneInputComponent
];

export function createTranslateLoader(http: HttpClient) {
  return new TranslateHttpLoader(http, "./assets/i18n/", ".json");
}

@NgModule({
  declarations: [
    sharedMComponents,
    ConvertGerogianToHijriPipe,
    ConfirmationDialogComponent,
    MomentPipe,
    GeneralErrorComponent,
    TrademarkInfoComponent,
    SelectedValueDirective,
    QcIdDirective,
    SafeUrlPipe,
    AutoTabDirective
  ],
  imports: [
    CommonModule,
    RouterModule,
    [...sharedModules],
    TranslateModule.forChild(),
    ToastrModule.forRoot()
  ],
  exports: [
    ...sharedModules,
    sharedMComponents,
    ConvertGerogianToHijriPipe,
    SelectedValueDirective,
    QcIdDirective,
    SafeUrlPipe,
    AutoTabDirective
  ],
  entryComponents: [ConfirmationDialogComponent],
  providers: [
    ConfirmationDialogService,
    AuthGuard,
    QueryService,
    EndpointsService,
    LoaderService,
    UrlSerializerService,
    MomentPipe,
    SafeUrlPipe,
    TradeMarkService,
    { provide: HTTP_INTERCEPTORS, useClass: AppInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: LoaderInterceptor, multi: true },
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA],
})
export class SharedModule {
  constructor(injector: Injector) {
    AppInjector.setInjector(injector);
  }

  static forRoot(): ModuleWithProviders<{}> {
    return {
      ngModule: SharedModule,
      providers: [...services],
    };
  }
}
